import './textfield.scss';

const TextField = ( props ) => {

  const { 

    value,
    set = () => {}, 
    title = '',
    type = 'text', 
    placeholder = '', 
    className = '',
    inputClassName = '', 
    refDOM = false, 
    onBlur = () => {}, 
    onKeyUp = () => {},
    error = ''

  } = props;

  return (

    <div className = {`textfield ${ className }`}>

      { title !== '' && <div className = {`textfield__title ${ error !== '' && 'textfield__title__error' }`}>{ title }</div> }

      <div className = 'relative'>
          
        <input

          ref = { refDOM ? refDOM : null }
          type = { type !== 'number' ? type : 'text' }
          value = { value }
          placeholder = { placeholder }
          className = {`textfield__input ${ error !== '' && 'textfield__input__error' } ${ inputClassName }`}
          onBlur = { onBlur }
          onKeyUp = { onKeyUp }
          onChange = { e => set( e.target.value ) }

        />

        { error !== '' && <div className = 'textfield__error'>{ error }</div> }

      </div>

    </div>

  );

};

export default TextField;